<i18n
  src="@/locales/views/service_provider/delivery/managing/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div
    v-if="load_general_data"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="delivery_process in delivery_processes"
        :key="delivery_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowProcess(delivery_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ delivery_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <router-link
                  class="link invisible sm:visible"
                  :to="{
                    name: this.routeName('show_process'),
                    params: {
                      service_provider_id: this.service_provider_id,
                      delivery_process_id: delivery_process.id,
                    },
                  }"
                >
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/list_processes.js";

export default {
  name: "SPDeliveryManagingListProcesses",
  props: { service_provider_id: { required: true } },
  data() {
    return {
      load_general_data: false,
      delivery_processes: [],
    };
  },
  methods: {
    fetchDeliveryProcesses: async function () {
      let response = await Requester.fetchDeliveryProcesses(
        this.service_provider_id
      );
      this.delivery_processes = response.data;
      this.load_general_data = true;
    },
    goToShowProcess: function (delivery_process) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: delivery_process.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.fetchDeliveryProcesses())
    );
  },
};
</script>
